"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockWire = void 0;
const events_1 = require("events");
class MockWire extends events_1.EventEmitter {
    connect(address) {
        throw new Error('You are not running in OpenFin.');
    }
    connectSync() {
        throw new Error('You are not running in OpenFin.');
    }
    send(data) {
        throw new Error('You are not running in OpenFin.');
    }
    shutdown() {
        throw new Error('You are not running in OpenFin.');
    }
    getPort() {
        throw new Error('This transport has no port');
    }
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super();
    }
}
exports.MockWire = MockWire;
